import * as dayjs from 'dayjs';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'day',
})
export class DayPipe implements PipeTransform {
  transform(day: number): string {
    const date = dayjs().set('day', day);
    const formatted = date.format('dddd');

    return formatted[0].toUpperCase() + formatted.slice(1);
  }

  constructor() {
    dayjs().locale('se');
  }
}
